import originFields from '../../defaults/PointOfOriginFields.json'
import moment from 'moment';
import * as esriLoader from 'esri-loader';

export async function filterIncidentsByState(selectedState, csvRecords) {

    return new Promise(resolve => {
        esriLoader.loadModules(['esri/geometry/Point', 'esri/geometry/SpatialReference', 'esri/geometry/geometryEngine', 'esri/geometry/support/jsonUtils'])
            .then(([Point, SpatialReference, geometryEngine, geometryJsonUtils]) => {
                window.api.getStateForUpload(selectedState).then(stateGeometry => {
                    let incidentsOutsideStateBuffer = [];
                    let expandedStateGeometry = geometryEngine.geodesicBuffer(geometryJsonUtils.fromJSON(stateGeometry.geometry), "10", "miles", true);
                    var rowCount = 0;

                    var latPosition = 0;  
                    var longPosition = 0; 
                
                    for (var i = 0; i < csvRecords.data[0].length; i++) 
                    {
                        if (csvRecords.data[0][i].toUpperCase() === "LATITUDE") 
                        {
                            latPosition = i;
                        }
                
                        if (csvRecords.data[0][i].toUpperCase() === "LONGITUDE") 
                        {
                            longPosition = i;
                        }
                    }
                
                    if (latPosition === 0 && longPosition === 0) 
                    {
                        console.log("Error: No Latitude or Longitude found in CSV");
                        resolve(null);
                    }
                    
                    csvRecords.data.forEach(record => {
                        if (rowCount === 0) 
                        {
                            rowCount++;
                            return;
                        }
                        
                        let recordPoint = new Point
                            ({
                                latitude: record[latPosition],
                                longitude: record[longPosition],
                                spatialReference: new SpatialReference(4326)
                            });

                        if (recordPoint) 
                        {   
                            try 
                            {
                                if (!geometryEngine.within(recordPoint, expandedStateGeometry)) 
                                {
                                    incidentsOutsideStateBuffer.push(rowCount);
                                }
                            } 
                            catch (err) 
                            {
                                debugger;
                            }
                        }
                        else { 
                            incidentsOutsideStateBuffer.push(rowCount);
                        }
                        rowCount++;
                    });

                    resolve(incidentsOutsideStateBuffer);
                });
            });
    });
}

export function getUnixTimeStampMs(args) {
    const dateTimeString = args.dateTime ? args.dateTime : args.time ? args.date + ' ' + args.time : args.date;
    const value = moment(dateTimeString, 'MM-DD-YYYY HHmm');
    return value.unix() * 1000;
}

export function getUniqueIdentifierForIncident(attributes) {
    const yearCode = new Date(attributes[originFields.discoveryDate]).getFullYear();
    const jurisdictionCode = (attributes.FireDepartmentID) ? attributes.FireDepartmentID : attributes.POOProtectingUnit;
    const localIncidentIdentifier = attributes[originFields.localIncidentIdentifier];

    let fullUFI = yearCode + "-" + jurisdictionCode + "-" + localIncidentIdentifier;
    if (fullUFI.length > 22) {
        fullUFI = fullUFI.substring(0, 22);
    }

    return fullUFI;
}

